import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
import axios from 'axios';
import Header from '@/components/landing/Header';
import HeroSection from '@/components/landing/HeroSection';
import SystemProvenSection from '@/components/landing/SystemProvenSection';
import HowItWorksSection from '@/components/landing/HowItWorksSection';
import ShowcaseSection from '@/components/landing/ShowcaseSection';
import SecuritySection from '@/components/landing/SecuritySection';
import PricingSection from '@/components/landing/PricingSection';
import BenefitsSection from '@/components/landing/BenefitsSection';
import CTASection from '@/components/landing/CTASection';
import ContactSection from '@/components/landing/ContactSection';
import Footer from '@/components/landing/Footer';
import AuthCard3D from '@/components/auth/AuthCard3D';

export default function LandingPage() {
  const [showAuth, setShowAuth] = useState(false);
  const [authMode, setAuthMode] = useState(null);
  const navigate = useNavigate();

  // Registra una visita una vez por sesión del navegador.
  useEffect(() => {
    try {
      if (sessionStorage.getItem('lexorbit_visit_logged')) return;
      sessionStorage.setItem('lexorbit_visit_logged', '1');
      const API = process.env.REACT_APP_BACKEND_URL || '';
      axios.post(`${API}/api/metricas/visita`).catch(() => {});
    } catch { /* noop */ }
  }, []);

  const openTrial = (plan) => { setAuthMode(plan || 'independiente'); setShowAuth(true); };
  const openLogin = () => { setAuthMode(null); setShowAuth(true); };
  const handleAuthSuccess = () => { setShowAuth(false); navigate('/dashboard'); };

  return (
    <div className="min-h-screen bg-[#050505]" data-testid="landing-page">
      <Header onTrialClick={() => openTrial()} onLoginClick={openLogin} />

      {/* Orden: Impacto → Confianza → Explicación → Prueba visual → Seguridad → Planes → Conversión */}
      <HeroSection onTrialClick={() => openTrial()} />
      <SystemProvenSection />
      <HowItWorksSection />
      <ShowcaseSection onTrialClick={() => openTrial()} />
      <SecuritySection />
      <PricingSection onSelectPlan={(plan) => openTrial(plan)} />
      <BenefitsSection />
      <CTASection onTrialClick={() => openTrial()} />
      <ContactSection />
      <Footer />

      <AnimatePresence>
        {showAuth && (
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.25 }}
            className="fixed inset-0 z-[100] flex items-center justify-center bg-black/88 backdrop-blur-md p-4 overflow-y-auto"
            onClick={e => { if (e.target === e.currentTarget) setShowAuth(false); }}
            data-testid="auth-modal-overlay">
            <motion.div initial={{ opacity: 0, scale: 0.96, y: 15 }} animate={{ opacity: 1, scale: 1, y: 0 }} exit={{ opacity: 0, scale: 0.96, y: 15 }}
              transition={{ duration: 0.35, ease: [0.23, 1, 0.32, 1] }} className="relative w-full max-w-[440px] my-8">
              <button onClick={() => setShowAuth(false)} className="absolute -top-10 right-0 text-[#B8B8B8] hover:text-[#F8F6F0] transition-colors z-10" data-testid="close-auth-modal">
                <X className="w-5 h-5" />
              </button>
              <AuthCard3D onSuccess={handleAuthSuccess} defaultPlan={authMode} />
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
